export const shiftStatuses = [
  {
    id: 'active',
    label: 'Active',
  },
  {
    id: 'cancelled',
    label: 'Cancelled',
  },
] as const

export type ShiftStatus = (typeof shiftStatuses)[number]['id']
